import React from 'react'
import PropTypes from 'prop-types'
import { SortableElement } from 'react-sortable-hoc'
import styles from './styles.css'

class SubOrderGroup extends React.PureComponent {

  static propTypes = {
    subOrderGroup: PropTypes.object.isRequired,
    setPercentage: PropTypes.number,
    onUpdateField: PropTypes.func.isRequired,
  }

  state = {
    name: undefined,
  }

  render() {

    const {
      subOrderGroup,
      setPercentage,
      onUpdateField,
    } = this.props

    return (

      <div className={styles.wrapper}>

        <input
          value={this.state.name !== undefined ? this.state.name : (subOrderGroup.name || '')}
          onChange={e => this.setState({ name: e.target.value })}
          onBlur={e => {
            onUpdateField(subOrderGroup.guid, 'name', e.target.value)
            this.setState({ name: undefined })
          }}
          placeholder='Untitled Group'
          className={styles.name}
        />

        <div className={styles.headings}>

          <div className={styles.cell}>
            Qty
          </div>

          <div className={styles.cell}>
            Unit
          </div>

          <div className={styles.cell}>
            Rate
          </div>

          {setPercentage && (
            <div className={styles.cell} style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>
              Subcontractor Total
            </div>
          )}

          <div className={styles.cell}>
            Company Total
          </div>

        </div>

      </div>

    )

  }

}

export default SortableElement(SubOrderGroup)
